import type { Class } from '../../models/Class';
import type { SupabaseClient } from 'jsr:@supabase/supabase-js@2';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, name, school_id, created_at`;

export class ClassRepository extends SupabaseRepository<Class> {
  constructor(client: SupabaseClient) {
    super('classes', selector, client);
  }
}
